export default __webpack_public_path__ + "static/media/section2-img2.e6e1f7b2.png";